module.exports = __webpack_public_path__ + "media/bootstrap-icons/rainbow-f9234115.svg";